module.exports = __webpack_public_path__ + "static/img/2.f43f3e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/2.png
// module id = fRrj
// module chunks = 0